import { render, staticRenderFns } from "./LexonKanbanCardTemplate.vue?vue&type=template&id=312ff66f&scoped=true&let-data=true&lang=pug"
import script from "./LexonKanbanCardTemplate.vue?vue&type=script&lang=ts"
export * from "./LexonKanbanCardTemplate.vue?vue&type=script&lang=ts"
import style0 from "./LexonKanbanCardTemplate.vue?vue&type=style&index=0&id=312ff66f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312ff66f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('312ff66f')) {
      api.createRecord('312ff66f', component.options)
    } else {
      api.reload('312ff66f', component.options)
    }
    module.hot.accept("./LexonKanbanCardTemplate.vue?vue&type=template&id=312ff66f&scoped=true&let-data=true&lang=pug", function () {
      api.rerender('312ff66f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LexonKanban/templates/LexonKanbanCardTemplate.vue"
export default component.exports